export default () => ({
  item: {
    marginBottom: '20px',
    position: 'relative',
  },
  gridItem: { padding: 5 },
  flex: {
    display: 'flex',
    flex: 1,
  },
  tagContainer: {
    display: 'flex',
    minHeight: 400,
    maxHeight: '100vh',
  },
});
